








import {Vue, Component} from "vue-property-decorator";
import Configuration from "front-component/Configuration";

@Component({
    methods: {
        Configuration() {
            return Configuration;
        }
    }
})
export default class EnvIndicator extends Vue {
    private get envIndicatorClasses(): Record<string, boolean> {
        return {
            "env-indicator": true,
            [`env-indicator--${Configuration.get("envIndicator")}`]: true,
        };
    }

    private get correctEnvIndicator(): boolean {
        return Configuration.get("envIndicator") === "staging" ||
            Configuration.get("envIndicator") === "preprod" ||
            Configuration.get("envIndicator") === "local";
    }

    public mounted() {
        const envIndicator = Configuration.get("envIndicator");
        if (envIndicator && this.correctEnvIndicator) {
            document.title = `[${envIndicator.toUpperCase()}] ${document.title}`;
        }
    }
}
